import { HttpClient,HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_URL } from '../common';

const BASE_URL = `${API_URL}/api/ICD10/`;
const BASE_URL_ICD9 = `${API_URL}/api/ICD9/`;

@Injectable({
    providedIn: 'root',
})
export class IcdServiceV1 {
    constructor(private httpClient: HttpClient) {

    }
  
    getChapter(lang: string) {
        return this.httpClient.get<any>(`${BASE_URL}root?lang=${lang}`);
    }

    getDetailModel(model: string, id: string, lang: string) {
        const headers = new HttpHeaders({
            'X-Client-IP': localStorage.getItem('client_ip') || ''
          });
        return this.httpClient.get<any>(`${BASE_URL}data/${model}?id=${id}&lang=dual`,
        { headers: headers });
    }

    getChildrenOfModel(model: string, id: string, lang: string) {
        return this.httpClient.get<any>(`${BASE_URL}childs/${model}?id=${id}&lang=${lang}`);
    }

    getChapter_ICD9(lang: string) {
        return this.httpClient.get<any>(`${BASE_URL_ICD9}root?lang=${lang}`);
    }

    getDetailModel_ICD9(model: string, id: string, lang: string) {
        const headers = new HttpHeaders({
            'X-Client-IP': localStorage.getItem('client_ip') || ''
          });
        return this.httpClient.get<any>(`${BASE_URL_ICD9}data/${model}?id=${id}&lang=dual`,
        { headers: headers });
    }

    getChildrenOfModel_ICD9(model: string, id: string, lang: string) {
        return this.httpClient.get<any>(`${BASE_URL_ICD9}childs/${model}?id=${id}&lang=${lang}`);
    }
}
